<template>
  <div class="assigned-tests" v-if="areThereAnyTests">
    <h3 class="section-title">
      {{ $t("KNOWLEDGE_TEST_FOCUS_TITLE") }}
    </h3>

    <div
      class="card knowledge-test-card"
      v-for="test in knowledgeTestsArray"
      :key="test.id"
      :class="{ 'knowledge-test-warning' : !didUserPassTest(test.id) && isTestClosingSoon(test.id) }"
    >
      <div class="test-name-row">
        <div class="test-name-main">
          <test-icon class="test-name-icon" />
          <h2>{{ test.title || $t("KNOWLEDGE_TEST_FOCUS_TITLE") }}</h2>
        </div>
        <span class="test-deadline-label">
          <calendar-warning class="deadline-warning-icon" />
          {{ test.open_to_formatted }}
        </span>
      </div>

      <attempts-indicator
        :total="maxTestAttempts(test.id)"
        :used="maxTestAttempts(test.id) - remainingTestAttempts(test.id)"
      />

      <div class="test-button-row">
        <button
          class="btn primary-btn"
          @click="continueAttempt()"
          v-if="isAttemptForTestActive(test.id)"
        >
          {{ "KNOWLEDGE_TEST_CONTINUE_ATTEMPT" | translate }}
        </button>
        <button
          class="btn primary-btn"
          @click="showStartModal(test.id)"
          v-else
          :disabled="remainingTestAttempts(test.id) === 0 || isAnyAttemptActive || didUserPassTest(test.id)"
        >
          {{ "KNOWLEDGE_TEST_START_ATTEMPT" | translate }}
        </button>

        <span class="test-status-text status-running" v-if="isAttemptForTestActive(test.id)">
          <timer /> {{ "KNOWLEDGE_TEST_UNFINISHED_ATTEMPT" | translate }}
        </span>
        <span class="test-status-text status-passed" v-else-if="didUserPassTest(test.id)">
          <check /> {{ "KNOWLEDGE_TEST_STATUS_PASSED" | translate }}
        </span>
        <span
          class="test-status-text status-no-attempts"
          v-else-if="remainingTestAttempts(test.id) === 0"
        >
          <incorrect /> {{ "KNOWLEDGE_TEST_STATUS_NO_ATTEMPTS" | translate }}
        </span>
        <span class="test-status-text status-locked" v-else-if="isAnyAttemptActive">
          <timer /> {{ "KNOWLEDGE_TEST_STATUS_LOCKED" | translate }}
        </span>
      </div>
    </div>
  </div>
</template>
<!---------------------------------------------------------------------------->
<script>
import { mapGetters } from "vuex";

import notificationService from "src/services/notificationService";
import userMessages from "src/services/userMessages";
import log from "src/services/logger";

import AttemptsIndicator from "Components/common/AttemptsIndicator";
import TestIcon from "Components/Svg/TestIcon";
import CalendarWarning from "Components/Svg/CalendarWarning";
import Timer from "Components/Svg/Timer";
import Check from "Components/Svg/Check";
import Incorrect from "Components/Svg/Incorrect";

const logTag = "AssignedTests";

export default {
  name: "AssignedTests",

  components: { AttemptsIndicator, TestIcon, CalendarWarning, Timer, Check, Incorrect },

  watch: {
    // tests are scoped to the area sent in the x-ifo-area header, so we can only download them once
    // the current area is settled - CategoryChooser switches it asynchronously via changePreferredArea
    currentAreaId: {
      immediate: true,
      handler(areaId) {
        if (!areaId) {
          return;
        }
        this.$store.dispatch("downloadKnowledgeTests").catch((reason) => {
          log.log(logTag, "Download of knowledge tests failed, reason follows");
          log.log(logTag, reason);
        });
      },
    },
  },

  computed: mapGetters([
    "currentAreaId",
    "areThereAnyTests", "knowledgeTestsArray", "currentAreaCssClass", "knowledgeTests",
    "isAttemptForTestActive", "isAnyAttemptActive", "maxTestAttempts", "remainingTestAttempts",
    "neededCorrectAnswers", "isTestClosingSoon", "didUserPassTest",
  ]),

  methods: {
    showStartModal(testId) {
      notificationService.knowledgeTestStart(
        this.currentAreaCssClass,
        this.neededCorrectAnswers(testId),
        this.knowledgeTests[testId].items_count,
        this.maxTestAttempts(testId),
        this.maxTestAttempts(testId) - this.remainingTestAttempts(testId),
        (result) => {
          if (result === true) {
            // ONLY this component, KnowledgeTestBox and TestResult can start a new test attempt!
            this.$store.dispatch("startTestAttempt", testId)

            .then(() => {
              this.$router.push("/test");
            })

            .catch((reason) => {
              log.log(logTag, "Start test attempt - error, reason follows:");
              log.log(logTag, reason);
              this.$store.dispatch("showErrorMessage", userMessages.afterStartTestAttempt(reason));
              // we might have had old test data - redownload
              this.$store.dispatch("downloadKnowledgeTests");
            });
          }
        }
      );
    },

    continueAttempt() {
      this.$router.push("/test");
    },
  },
};
</script>
<!---------------------------------------------------------------------------->
<style lang="scss" type="text/scss">
</style>
